import React, { Dispatch, SetStateAction, useCallback } from 'react'
import { ScheduleType } from 'types/schedule'
import { StockUnionType } from 'types/stock'
import { getUpdateSchedulesFunction } from 'components/Templates/product/ProductEditTemplate'

const useUpdateNote = (
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>
): ((event: React.FocusEvent<HTMLTextAreaElement>, type: StockUnionType) => void) => {
  return useCallback(
    (event: React.FocusEvent<HTMLTextAreaElement>, type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState.map((schedule) => {
          schedule.note = event.target.value
          return schedule
        })
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useUpdateNote
